import { SET_SEARCH_TYPE } from '../../constants/ordersSearchActionTypes';
import { SET_INTEGRATION_OPTIONS } from 'actions/types';

const INITIAL_STATE = {
  alertManagerType: null,
  integrationOptions: {},
};

const general = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SELECTED_TOOL':
      return Object.assign({}, state, {
        selectedTool: action.name,
      });
    case SET_SEARCH_TYPE:
      return Object.assign({}, state, {
        searchType: action.searchType,
      });
    case 'SELECT_TOOL_DOMAINS':
      return Object.assign({}, state, {
        selectedToolDomains: action.domains,
      });
    case 'ADD_AND_SELECT_TOOL_DOMAINS':
      return {
        ...state,
        toolDomains: {
          [action.account]: action.domains,
        },
        selectedToolDomains: action.domains,
      };
    case SET_INTEGRATION_OPTIONS:
      return {
        ...state,
        integrationOptions: {
          ...state.integrationOptions,
          [action.simplrAccountId]: action.data,
        },
      };
    default:
      return state;
  }
};

export default general;
